import { render, staticRenderFns } from "./Withdraws.vue?vue&type=template&id=3f6078bb&scoped=true&"
import script from "./Withdraws.vue?vue&type=script&lang=js&"
export * from "./Withdraws.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6078bb",
  null
  
)

export default component.exports